export default __webpack_public_path__ + "static/media/poor_connectivity.a55fb7cb.svg";